// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-table-with-cross';

export const Component = () => (
  <>
    <path d='M0 2v21h24V2H0Zm7.5 14.5H1v-5h6.5v5Zm-6.5-6v-5h6.5v5H1Zm7.5-5h6.75v5H8.5v-5Zm7.75 0H23v5h-6.75v-5ZM1 17.5h6.5V22H1v-4.5ZM8.5 22V11.5H23V22H8.5Z' />
    <path d='M19.28 13.95h-2.03l-1.28 2.09-1.27-2.09h-2.03l2.11 3.2-2.22 3.35h2.03l1.38-2.24 1.38 2.24h2.03l-2.23-3.35z' />
  </>
);

export const viewBox = '0 0 25 25';
